import { alertController, toastController } from '@ionic/core';

export const toastError = async (error, duration = 5) => {
    const toast = await toastController.create({
        message: error.message || error,
        duration: duration * 1000,
        color: 'danger',
    });
    await toast.present();
};

export const toastCall = async (message, duration = 5) => {
    const toast = await toastController.create({
        message,
        duration: duration * 1000,
        color: 'success',
    });
    await toast.present();
};

export async function presentToast(message: string, color = 'success', duration = 3000, position: 'top' | 'bottom' | 'middle' = 'bottom') {
    const toast = await toastController.create({
        message,
        duration,
        position,
        color,
    });
    toast.present();
}

export async function presentAlert(header: string, subHeader: string, message: string) {
    const alert = await alertController.create({
        cssClass: 'custom-alert',
        header,
        subHeader,
        message,
        buttons: ['OK'],
    });

    await alert.present();
}
